import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import PackVariation from './PackVariation';
import ProductVariationsProp from '../../propTypes/productVariationsProp';
import ShopProductVariationQuantity from '../ShopProductVariationQuantity';

function PackVariations(props) {
  const { t, product, onPackQuantityChange, packQuantity } = props;
  const { packVariations = [] } = product;
  return (
    <div className="pack-container">
      {packVariations.map(packVariation => (
        <PackVariation
          key={packVariation._id}
          packVariation={packVariation}
          {...props}
        />
      ))}
      <div className="product-info-item variation">
        <div className="product-info-wrapper">
          <div className="pack-quantity-wrapper">
            <p className="pack-quantity">{t('shop.pack.quantity')}</p>
            <ShopProductVariationQuantity
              index={1}
              handleChange={onPackQuantityChange}
              variation={product}
              currentVariation={{ ...product, amount: packQuantity }}
              isTouched
              showLabel={false}
              hideMinusButtonThreshold={1}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PackVariations.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape({
    packVariations: PropTypes.arrayOf(
      PropTypes.shape(ProductVariationsProp.propType),
    ),
  }).isRequired,
  onPackQuantityChange: PropTypes.func.isRequired,
  isTouched: PropTypes.bool.isRequired,
  packQuantity: PropTypes.number.isRequired,
};

PackVariations.defualtProps = {};

export default translate(PackVariations);
